import { render, staticRenderFns } from "./seckillPrice.vue?vue&type=template&id=19c53dde&scoped=true&"
import script from "./seckillPrice.vue?vue&type=script&lang=js&"
export * from "./seckillPrice.vue?vue&type=script&lang=js&"
import style0 from "./seckillPrice.vue?vue&type=style&index=0&id=19c53dde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c53dde",
  null
  
)

export default component.exports